import { Dialog, Grid, Typography } from "@mui/material";
import classNames from "classnames";
import { useBlocker } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import warning from "../../assets/images/warning.png";
import withRouter from "../withRouter";
import DialogActions from "./DialogActions";
import DialogContent from "./DialogContent";
import DialogTitle from "./DialogTitle";

const useStyles = makeStyles()((theme: any) => ({
  contentSpacing: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  gridContainer: {
    alignItems: "center",
    justifyContent: "space-around",
  },
  gridContainerImage: {
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    width: "82px",
  },
  modalContainer: {
    margin: "auto",
    maxWidth: "703px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  subheader: {
    color: theme.palette.text.modalSubheader,
    fontSize: theme.typography.pxToRem(22),
    lineHeight: theme.typography.pxToRem(28),
  },
  text: {
    color: theme.palette.text.modalText,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(28),
  },
}));

interface ComponentPropsType {
  when: boolean;
}

const PromptUnsavedChanges = (props: ComponentPropsType) => {
  const { classes } = useStyles();

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      props.when === true && currentLocation.pathname !== nextLocation.pathname
    );
  });

  const handleAcceptCancelForm = () => {
    if (blocker.state === "blocked") {
      blocker.proceed();
    }
  };

  const handleCloseModal = () => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
  };

  return (
    <>
      <Dialog
        className={classes.modalContainer}
        onClose={handleCloseModal}
        aria-labelledby="warning-dialog-title"
        open={blocker.state === "blocked"}
        PaperProps={{ square: true }}
      >
        <DialogTitle id="warning-dialog-title" showCloseIcon={false}>
          Are you sure you want to cancel?
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={4} className={classes.gridContainer}>
            <Grid container item xs={3} className={classes.gridContainerImage}>
              <img src={warning} alt="Warning" className={classes.image} />
            </Grid>
            <Grid item xs>
              <Typography
                gutterBottom
                className={classNames(
                  classes.subheader,
                  classes.contentSpacing
                )}
              >
                You have unsaved changes.
              </Typography>
              <Typography
                gutterBottom
                className={classNames(classes.text, classes.contentSpacing)}
              >
                Cancelling or quitting now will cause all unsaved data to be
                lost. If you are positive, click continue.
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          acceptButtonText="Continue"
          onAccept={handleAcceptCancelForm}
          onDismiss={handleCloseModal}
          closeButtonText="Cancel"
        />
      </Dialog>
    </>
  );
};

export default withRouter(PromptUnsavedChanges);
